import { inlines } from './inlines';
export var decisionItem = function decisionItem(node) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    context = _ref.context;
  var result = '';
  node.forEach(function (n) {
    result += "* <> ".concat(inlines(n, {
      context: context
    }));
  });
  return result;
};